module.exports = require("font-awesome/css/font-awesome.css");